import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class CancellationReasonOption extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    option: PropTypes.any.isRequired,
    selected: PropTypes.bool.isRequired,
  }

  render() {
    const { onClick, option, selected } = this.props
    return (
      <button className={`list-group-item ${selected && 'active'}`} onClick={() => onClick(option.value)}>
        {option.displayName}
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/SubscriptionCancellation/components/CancellationReasonOption.js